import { classNames } from '@fullstory/util/fmt';
import React, { useContext } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { BaseItem } from './BaseItem';
import { Context } from './Context';
import css from './index.module.scss';

export interface LinkItemProps extends LinkProps {
  label: string;
}

export const LinkItem: React.FunctionComponent<LinkItemProps> = ({ label, ...rest }) => {
  const { linkColor, testId } = useContext(Context);
  const classes = classNames(css.actionableListItem, {
    [css.linkListItemInherit]: linkColor === 'inherit',
  });
  return (
    <BaseItem
      data-component="InfoListLinkItem"
      testId={`${testId}-linkItem`}
      className={css.actionableListItem}
    >
      <Link className={classes} {...rest}>
        {label}
      </Link>
    </BaseItem>
  );
};
